<button type="button" class="one-icon-btn"
        [class.one-icon-btn-sm]="size() === 'sm'" [class.is-active]="active()"
        [disabled]="disabled()" [attr.aria-label]="ariaLabel()"
        (click)="onClick()">
  <mat-icon>{{ icon() }}</mat-icon>
</button>
